import Vue from 'vue/dist/vue.esm.js';
import {setCookie} from "@ckeditor/ckeditor5-adapter-ckfinder/src/utils";
import {formatPrice} from '../utility/formatPrice'


Vue.component('late-checkout-widget', {
    name: 'late-checkout-widget',
    template: `#late-checkout-widget`,
    delimiters: ['[[', ']]'],
    props: {
        categoryId: {
            required: true,
            type: String,
        },
        timeLeft: {
            required: true,
            type: String,
        },
        orderPrice: {
            required: true,
            type: Number,
        },
        orderNumber: {
            required: true,
            type: Number,
        },
        products: {
            required: true,
            type: Array
        },
        exchangeRate: {
            required: true,
            type: String,
        },
        exchangeRateMode: {
            required: true,
            type: String,
        },
        convertMode: {
            required: true,
            type: String,
        },
        showEurFirst: {
            required: false,
            type: String,
            default: '0'
        }
    },
    mounted() {
        this.initAddToCartTracking();

        window.addEventListener('pageshow', this.checkLateCheckoutAvailableCookie);

        this.countdownInterval = setInterval(() => {
            if (this.secondsLeft > 0) {
                this.secondsLeft--;
            } else {
                this.isExpired = true
                clearInterval(this.countdownInterval); // Clear the interval when the time is over
            }
        }, 1000);
    },
    data() {
        return {
            orderCartPrice: this.orderPrice,
            currentPrice: 0,
            number: this.orderNumber,
            totalDiscount: 0,
            totalQuantity: 0,
            secondsLeft: this.timeLeft, // in seconds
            countdownInterval: null,
            isExpired: false,
            exchangeRate: this.exchangeRate,
            exchangeRateMode: this.exchangeRateMode,
            convertMode: this.convertMode,
        }
    },
    methods: {
        formatDualPrice(price) {
            return formatPrice(price, this.exchangeRate, this.exchangeRateMode, this.convertMode, true, this.showEurFirst);
        },
        initAddToCartTracking() {
            // Delete the cookie
            this.clearCookie()

            this.calculateTotals();

            // One delegated listener: the carousel moves the product markup around, and per-button
            // listeners would be attached again every time a product is re-added.
            this.$el.addEventListener('click', (e) => {
                if (this.isExpired) {
                    return;
                }

                const addButton = e.target.closest('[data-controller="add-variant-to-cart"]');
                const increaseButton = e.target.closest('.qty-increase');
                const decreaseButton = e.target.closest('.qty-decrease');
                const button = addButton || increaseButton || decreaseButton;
                if (!button || !this.$el.contains(button)) {
                    return;
                }

                e.preventDefault();
                const container = button.closest('.late-checkout-action');
                const variantId = parseInt(container.querySelector('[data-controller="add-variant-to-cart"]').getAttribute('data-id'), 10);

                if (addButton) {
                    this.addProduct(container, variantId);
                } else if (increaseButton) {
                    this.changeQuantity(container, variantId, 1);
                } else {
                    this.changeQuantity(container, variantId, -1);
                }
            });
        },
        findProduct(variantId) {
            return this.products.find(p => p.variantId == variantId);
        },
        addProduct(container, variantId) {
            if (!this.findProduct(variantId)) {
                return;
            }

            const lateCheckoutProducts = JSON.parse(this.getCookie('lateCheckoutProducts') || '[]');
            if (!lateCheckoutProducts.find(p => p.id === variantId)) {
                lateCheckoutProducts.push({ id: variantId, quantity: 1 });
                this.setCookie('lateCheckoutProducts', lateCheckoutProducts, 1);
            }
            this.calculateTotals();

            container.querySelector('[data-controller="add-variant-to-cart"]').classList.add('d-none');
            const qtyControls = container.querySelector('.qty-controls');
            qtyControls.classList.remove('d-none');
            qtyControls.querySelector('.qty-value').textContent = 1;
            qtyControls.querySelector('.qty-decrease').classList.add('disabled');
        },
        changeQuantity(container, variantId, delta) {
            const product = this.findProduct(variantId);
            const qtyValue = container.querySelector('.qty-value');
            const qtyDecrease = container.querySelector('.qty-decrease');
            const qty = parseInt(qtyValue.textContent, 10) + delta;

            if (qty <= 0) {
                this.removeProductFromStorage(variantId);
                container.querySelector('.qty-controls').classList.add('d-none');
                container.querySelector('[data-controller="add-variant-to-cart"]').classList.remove('d-none');
                return;
            }

            if (delta > 0 && product && qty > product.maxQuantity) {
                return;
            }

            qtyValue.textContent = qty;
            this.updateProductQtyInStorage(variantId, qty);
            qtyDecrease.classList.toggle('disabled', qty === 1);
        },
        getCookie(name) {
            const nameEQ = name + "=";
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i].trim();
                if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        },
        clearCookie() {
            const d = new Date();
            d.setTime(d.getTime() - 1); // Set expiration to the past
            const expires = "expires=" + d.toUTCString();
            document.cookie = "lateCheckoutProducts" + "=; " + expires + "; path=/";
        },
        updateProductQtyInStorage(productId, qty) {
            let items = JSON.parse(this.getCookie('lateCheckoutProducts') || '[]');
            const idx = items.findIndex(p => p.id === productId);
            if (idx !== -1) {
                items[idx].quantity = qty;
                this.setCookie('lateCheckoutProducts', items, 1);
            }
            this.calculateTotals();
        },
        removeProductFromStorage(productId) {
            let items = JSON.parse(this.getCookie('lateCheckoutProducts') || '[]');
            items = items.filter(p => p.id !== productId);
            this.setCookie('lateCheckoutProducts', items, 1);
            this.calculateTotals();
        },
        setCookie(name, value, days) {
            const d = new Date();
            d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
            const expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + JSON.stringify(value) + ";" + expires + ";path=/";
        },
        calculateTotals() {
            const items = JSON.parse(this.getCookie('lateCheckoutProducts') || '[]');
            let totalQty = 0;
            let totalPrice = 0;
            let totalDiscount = 0;

            items.forEach(item => {
                const product = this.findProduct(item.id);
                if (!product) {
                    return;
                }

                totalQty += item.quantity;
                totalPrice += item.quantity * product.discountPrice;
                totalDiscount += item.quantity * product.discount;
            });

            this.totalDiscount = totalDiscount;
            this.totalQuantity = totalQty;
            this.currentPrice = totalPrice;
        },
        getLateCheckoutAvailableCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
            return null;
        },
        checkLateCheckoutAvailableCookie() {
            const cookieValue = this.getLateCheckoutAvailableCookie('LATECHECKOUT');

            if (cookieValue) {
                document.cookie = "LATECHECKOUT=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                window.location.reload();
            } else {
                document.cookie = "LATECHECKOUT=yes; path=/; max-age=610";
            }
        }
    },

    computed: {
        paddedMinutes() {
            const minutes = Math.floor(this.secondsLeft / 60);
            return minutes.toString().padStart(2, '0');
        },
        paddedSeconds() {
            const seconds = this.secondsLeft % 60;
            return seconds.toString().padStart(2, '0');
        },
        timerDisplay() {
            return `${this.paddedMinutes}:${this.paddedSeconds}`;
        },
        fullTotalPrice() {
            return parseFloat((this.orderCartPrice + this.currentPrice).toFixed(2));
        },
        fullDiscountPrice() {
            return parseFloat((this.totalDiscount).toFixed(2));
        }

    },
    watch: {
        isExpired(newValue) {
            if (newValue) {
                const buttons = this.$el.querySelectorAll('[data-controller="add-variant-to-cart"]');

                buttons.forEach(button => {
                    button.classList.add('disabled');
                    button.setAttribute('disabled', 'true');
                    const container = button.closest('.late-checkout-action');
                    const qtyDecrease = container.querySelector('.qty-decrease');
                    const qtyIncrease = container.querySelector('.qty-increase');

                    qtyDecrease.classList.add('disabled');
                    qtyIncrease.classList.add('disabled');

                });

                this.clearCookie()
            }
        }

    },

});
